module.exports = __webpack_public_path__ + "static/media/credit-card.8cd3ea62.png";